type tSlbConfigChangeMessage = {
  type: 'config-changed';
  workspaceId: string;
  aiRespondEnabled: boolean;
  funnelId?: string | null;
  // AGI-16 (F9): the full bot-active funnel set (multi-funnel). Consumers that
  // highlight per-funnel Lead Agent state (e.g. the Pipe "Lead Agent (N)" badge)
  // must key on membership in this set, not equality with the singular funnelId
  // (which is only the primary). Optional/back-compat: absent from older senders.
  funnelIds?: string[];
};

let channel: BroadcastChannel | null = null;

function getChannel(): BroadcastChannel {
  if (!channel) channel = new BroadcastChannel('slb-config');
  return channel;
}

export function postSlbConfigChange(
  workspaceId: string,
  aiRespondEnabled: boolean,
  funnelId?: string | null,
  funnelIds?: string[],
): void {
  getChannel().postMessage({ type: 'config-changed', workspaceId, aiRespondEnabled, funnelId, funnelIds } satisfies tSlbConfigChangeMessage);
}

export function onSlbConfigChange(cb: (msg: tSlbConfigChangeMessage) => void): () => void {
  const ch = getChannel();
  const handler = (e: MessageEvent) => {
    if (e.data?.type === 'config-changed') cb(e.data);
  };
  ch.addEventListener('message', handler);
  return () => ch.removeEventListener('message', handler);
}
